import React from 'react';
import { ErrorContext } from './Context/Error/errorContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      correlationId: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ERROR BOUNDARY CAUGHT:', error);
    console.error('Component Stack:', errorInfo.componentStack);
    const cid =
      error?.response?.data?.correlationId ||
      error?.response?.headers?.['x-correlation-id'] ||
      error?.response?.headers?.['X-Correlation-Id'] ||
      null;
    this.setState({
      error: error,
      errorInfo: errorInfo,
      correlationId: cid,
    });
    try {
      if (this.context && typeof this.context.addError === 'function') {
        this.context.addError({
          message: error?.message || 'Unhandled error',
          correlationId: cid,
        });
      }
    } catch (_) {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '20px',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            border: '1px solid #f5c6cb',
            borderRadius: '4px',
            fontFamily: 'monospace',
            margin: '20px',
          }}
        >
          <h2>Something went wrong</h2>
          {this.state.correlationId && (
            <p style={{ marginTop: '8px' }}>
              Correlation ID: <code>{this.state.correlationId}</code>{' '}
              <button
                onClick={() => {
                  try {
                    navigator.clipboard.writeText(this.state.correlationId);
                  } catch (e) {
                    console.error('Copy failed', e);
                  }
                }}
                style={{ marginLeft: '8px' }}
              >
                Copy
              </button>
            </p>
          )}
          <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
            <summary>Error details:</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.contextType = ErrorContext;

export default ErrorBoundary;
